import { fetchItems } from "../../utils/fetchItemData";
import { useModalStack } from "../../utils/modalContext";

const PetDrops = () => {
  const { pushModal } = useModalStack();

  const petCategories = [
    {
      category: "Chickens",
      pets: [
        {
          name: "Adult",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Chicken.gif",
          drops: [
            { id: "itm_turd",             name: "Animal Turd",      level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
            { id: "itm_egg",              name: "Egg",              level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
            { id: "itm_seltsamEgg",       name: "Seltsam Egg",      level: 8,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
            { id: "itm_offspring_chicken",name: "Chicken Offspring", level: 15, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
          ],
        },
        {
          name: "Baby I",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Chicken1.gif",
          drops: [
            { id: "itm_turd",       name: "Animal Turd", level: 0, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
            { id: "itm_egg",        name: "Egg",         level: 0, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
            { id: "itm_seltsamEgg", name: "Seltsam Egg", level: 8, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
          ],
        },
        {
          name: "Baby II",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Chicken2.gif",
          drops: [
            { id: "itm_turd",        name: "Animal Turd", level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_egg",         name: "Egg",         level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_seltsamEgg",  name: "Seltsam Egg", level: 8,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_eggsplosive", name: "Eggsplosive", level: 12, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby III",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Chicken3.gif",
          drops: [
            { id: "itm_turd",      name: "Animal Turd", level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_egg",       name: "Egg",         level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_seltsamEgg",name: "Seltsam Egg", level: 8,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_goldenEgg", name: "Golden Egg",  level: 15, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby IV",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Chicken4.gif",
          drops: [
            { id: "itm_turd",             name: "Animal Turd", level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "3" },
            { id: "itm_egg",              name: "Egg",         level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "3" },
            { id: "itm_seltsamEgg",       name: "Seltsam Egg", level: 8,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "3" },
            { id: "itm_eggsplosive",      name: "Eggsplosive", level: 12, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "3" },
            { id: "itm_goldenEgg",        name: "Golden Egg",  level: 15, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "3" },
            { id: "itm_chicken_spaceEgg", name: "Space Egg",   level: 20, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "3" },
          ],
        },
      ],
    },
    {
      category: "Slugs",
      pets: [
        {
          name: "Adult",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Slug.gif",
          drops: [
            { id: "itm_turd",           name: "Animal Turd",    level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "1" },
            { id: "itm_silkfiber",      name: "Silk Fiber",     level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "1" },
            { id: "itm_silkslugslime",  name: "Silk Slug Slime",level: 6,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "1" },
            { id: "itm_offspring_slug", name: "Slug Offspring", level: 20, feed: "itm_apimix", feedName: "Apimix", feedAmt: "1" },
          ],
        },
        {
          name: "Baby I",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Slug1.gif",
          drops: [
            { id: "itm_turd",         name: "Animal Turd",    level: 0, feed: "itm_apimix", feedName: "Apimix", feedAmt: "1" },
            { id: "itm_silkfiber",    name: "Silk Fiber",     level: 0, feed: "itm_apimix", feedName: "Apimix", feedAmt: "1" },
            { id: "itm_silkslugslime",name: "Silk Slug Slime",level: 6, feed: "itm_apimix", feedName: "Apimix", feedAmt: "1" },
          ],
        },
        {
          name: "Baby II",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Slug2.gif",
          drops: [
            { id: "itm_turd",           name: "Animal Turd",     level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
            { id: "itm_silkfiber",      name: "Silk Fiber",      level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
            { id: "itm_silkslugslime",  name: "Silk Slug Slime", level: 6,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
            { id: "itm_silkslugspider", name: "Silk Slug Spider",level: 18, feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby III",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Slug3.gif",
          drops: [
            { id: "itm_turd",             name: "Animal Turd",    level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
            { id: "itm_silkfiber",        name: "Silk Fiber",     level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
            { id: "itm_silkslugslime",    name: "Silk Slug Slime",level: 6,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
            { id: "itm_slug_shimmerSlime",name: "Shimmer Slime",  level: 20, feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby IV",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Slug4.gif",
          drops: [
            { id: "itm_turd",             name: "Animal Turd",     level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "3" },
            { id: "itm_silkfiber",        name: "Silk Fiber",      level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "3" },
            { id: "itm_silkslugslime",    name: "Silk Slug Slime", level: 6,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "3" },
            { id: "itm_silkslugspider",   name: "Silk Slug Spider",level: 18, feed: "itm_apimix", feedName: "Apimix", feedAmt: "3" },
            { id: "itm_slug_shimmerSlime",name: "Shimmer Slime",   level: 20, feed: "itm_apimix", feedName: "Apimix", feedAmt: "3" },
            { id: "itm_QueenSpider",      name: "Queen Spider",    level: 32, feed: "itm_apimix", feedName: "Apimix", feedAmt: "3" },
          ],
        },
      ],
    },
    {
      category: "Bee",
      pets: [
        {
          name: "Adult",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Bee.gif",
          drops: [
            { id: "itm_turd",         name: "Animal Turd",  level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
            { id: "itm_honey",        name: "Honey",        level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
            { id: "itm_beeswax",      name: "Bees Wax",     level: 8,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
            { id: "itm_offspring_bee",name: "Bee Offspring", level: 25, feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby I",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Bee1.gif",
          drops: [
            { id: "itm_turd",   name: "Animal Turd", level: 0, feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
            { id: "itm_honey",  name: "Honey",       level: 0, feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
            { id: "itm_beeswax",name: "Bees Wax",    level: 8, feed: "itm_apimix", feedName: "Apimix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby II",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Bee2.gif",
          drops: [
            { id: "itm_turd",          name: "Animal Turd", level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "4" },
            { id: "itm_honey",         name: "Honey",       level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "4" },
            { id: "itm_beeswax",       name: "Bees Wax",    level: 8,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "4" },
            { id: "itm_bee_royalJelly",name: "Royal Jelly", level: 23, feed: "itm_apimix", feedName: "Apimix", feedAmt: "4" },
          ],
        },
        {
          name: "Baby III",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Bee3.gif",
          drops: [
            { id: "itm_turd",      name: "Animal Turd", level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "4" },
            { id: "itm_honey",     name: "Honey",       level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "4" },
            { id: "itm_beeswax",   name: "Bees Wax",    level: 8,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "4" },
            { id: "itm_bee_pollen",name: "Pollen",      level: 28, feed: "itm_apimix", feedName: "Apimix", feedAmt: "4" },
          ],
        },
        {
          name: "Baby IV",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Bee4.gif",
          drops: [
            { id: "itm_turd",          name: "Animal Turd",   level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "6" },
            { id: "itm_honey",         name: "Honey",         level: 0,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "6" },
            { id: "itm_beeswax",       name: "Bees Wax",      level: 8,  feed: "itm_apimix", feedName: "Apimix", feedAmt: "6" },
            { id: "itm_bee_royalJelly",name: "Royal Jelly",   level: 23, feed: "itm_apimix", feedName: "Apimix", feedAmt: "6" },
            { id: "itm_bee_pollen",    name: "Pollen",        level: 28, feed: "itm_apimix", feedName: "Apimix", feedAmt: "6" },
            { id: "itm_bee_babyWings", name: "Baby Bee Wings",level: 38, feed: "itm_apimix", feedName: "Apimix", feedAmt: "6" },
          ],
        },
      ],
    },
    {
      category: "Cow",
      pets: [
        {
          name: "Adult",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Cow.gif",
          drops: [
            { id: "itm_turd",          name: "Animal Turd",   level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
            { id: "itm_milk",          name: "Milk",          level: 5,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
            { id: "itm_cow_dairyFat",  name: "Dairy Fat",     level: 10, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
            { id: "itm_offspring_cow", name: "Cow Offspring", level: 25, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
          ],
        },
        {
          name: "Baby I",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Cow1.gif",
          drops: [
            { id: "itm_turd",        name: "Animal Turd", level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
            { id: "itm_milk",        name: "Milk",        level: 5,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
            { id: "itm_cow_dairyFat",name: "Dairy Fat",   level: 10, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "1" },
          ],
        },
        {
          name: "Baby II",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Cow2.gif",
          drops: [
            { id: "itm_turd",           name: "Animal Turd", level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_milk",           name: "Milk",        level: 5,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_cow_dairyFat",   name: "Dairy Fat",   level: 10, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_cow_buttermilk", name: "Buttermilk",  level: 25, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby III",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Cow3.gif",
          drops: [
            { id: "itm_turd",           name: "Animal Turd", level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_milk",           name: "Milk",        level: 5,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_cow_dairyFat",   name: "Dairy Fat",   level: 10, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_cow_cheeseClump",name: "Cheese Clump",level: 32, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby IV",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Cow4.gif",
          drops: [
            { id: "itm_turd",           name: "Animal Turd",        level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "3" },
            { id: "itm_milk",           name: "Milk",               level: 5,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "3" },
            { id: "itm_cow_dairyFat",   name: "Dairy Fat",          level: 10, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "3" },
            { id: "itm_cow_buttermilk", name: "Buttermilk",         level: 25, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "3" },
            { id: "itm_cow_cheeseClump",name: "Cheese Clump",       level: 32, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "3" },
            { id: "itm_cow_grassClump", name: "Chewed Grass Clump", level: 38, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "3" },
          ],
        },
      ],
    },
    {
      category: "Sheep",
      pets: [
        {
          name: "Adult",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Sheep.gif",
          drops: [
            { id: "itm_turd",            name: "Animal Turd",    level: 0,  feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "1" },
            { id: "itm_woolyweedFruit",  name: "Wool Wad",       level: 8,  feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "1" },
            { id: "itm_sheep_lanolinOil",name: "Lanolin Oil",    level: 15, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "1" },
            { id: "itm_offspring_sheep", name: "Sheep Offspring",level: 30, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "1" },
          ],
        },
        {
          name: "Baby I",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Sheep1.gif",
          drops: [
            { id: "itm_turd",            name: "Animal Turd", level: 0,  feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "1" },
            { id: "itm_woolyweedFruit",  name: "Wool Wad",    level: 8,  feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "1" },
            { id: "itm_sheep_lanolinOil",name: "Lanolin Oil", level: 15, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "1" },
          ],
        },
        {
          name: "Baby II",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Sheep2.gif",
          drops: [
            { id: "itm_turd",               name: "Animal Turd",        level: 0,  feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
            { id: "itm_woolyweedFruit",     name: "Wool Wad",           level: 8,  feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
            { id: "itm_sheep_lanolinOil",   name: "Lanolin Oil",        level: 15, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
            { id: "itm_sheep_babyWoolPuff", name: "Fine Baby Wool Puff",level: 32, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
          ],
        },
        {
          name: "Baby III",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Sheep3.gif",
          drops: [
            { id: "itm_turd",             name: "Animal Turd",  level: 0,  feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
            { id: "itm_woolyweedFruit",   name: "Wool Wad",     level: 8,  feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
            { id: "itm_sheep_lanolinOil", name: "Lanolin Oil",  level: 15, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
            { id: "itm_sheep_knottedWool",name: "Knotted Wool", level: 40, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
          ],
        },
        {
          name: "Baby IV",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Sheep4.gif",
          drops: [
            { id: "itm_turd",               name: "Animal Turd",        level: 0,  feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "3" },
            { id: "itm_woolyweedFruit",     name: "Wool Wad",           level: 8,  feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "3" },
            { id: "itm_sheep_lanolinOil",   name: "Lanolin Oil",        level: 15, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "3" },
            { id: "itm_sheep_babyWoolPuff", name: "Fine Baby Wool Puff",level: 32, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "3" },
            { id: "itm_sheep_knottedWool",  name: "Knotted Wool",       level: 40, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "3" },
            { id: "itm_sheep_hoofDust",     name: "Mini Hoof Dust",     level: 50, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "3" },
          ],
        },
      ],
    },
    {
      category: "Turkey",
      pets: [
        {
          name: "Adult",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Turkey.gif",
          drops: [
            { id: "itm_turd",                   name: "Animal Turd",     level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_thanksgiving_turkeyegg", name: "Turkey Egg",      level: 3,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_feather_01",             name: "Turkey Feather",  level: 18, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_offspring_turkey",       name: "Turkey Offspring",level: 40, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby I",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Turkey1.gif",
          drops: [
            { id: "itm_turd",                   name: "Animal Turd",    level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_thanksgiving_turkeyegg", name: "Turkey Egg",     level: 3,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_feather_01",             name: "Turkey Feather", level: 18, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby II",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Turkey2.gif",
          drops: [
            { id: "itm_turd",                   name: "Animal Turd",    level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
            { id: "itm_thanksgiving_turkeyegg", name: "Turkey Egg",     level: 3,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
            { id: "itm_feather_01",             name: "Turkey Feather", level: 18, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
            { id: "itm_turkey_blueFeather",     name: "Blue Feather",   level: 45, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
          ],
        },
        {
          name: "Baby III",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Turkey3.gif",
          drops: [
            { id: "itm_turd",                   name: "Animal Turd",     level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
            { id: "itm_thanksgiving_turkeyegg", name: "Turkey Egg",      level: 3,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
            { id: "itm_feather_01",             name: "Turkey Feather",  level: 18, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
            { id: "itm_turkey_colorfulFeather", name: "Colorful Feather",level: 52, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
          ],
        },
        {
          name: "Baby IV",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Turkey4.gif",
          drops: [
            { id: "itm_turd",                   name: "Animal Turd",            level: 0,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "6" },
            { id: "itm_thanksgiving_turkeyegg", name: "Turkey Egg",             level: 3,  feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "6" },
            { id: "itm_feather_01",             name: "Turkey Feather",         level: 18, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "6" },
            { id: "itm_turkey_blueFeather",     name: "Blue Feather",           level: 45, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "6" },
            { id: "itm_turkey_colorfulFeather", name: "Colorful Feather",       level: 52, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "6" },
            { id: "itm_turkey_rainbowBristles", name: "Rainbow Turkey Bristles",level: 60, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "6" },
          ],
        },
      ],
    },
    {
      category: "Pig",
      pets: [
        {
          name: "Adult",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Pig.gif",
          drops: [
            { id: "itm_turd",          name: "Animal Turd",  level: 18, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
            { id: "itm_pig_truffles",  name: "Truffles",     level: 18, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
            { id: "itm_pig_pigMilk",   name: "Pig Milk",     level: 22, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
            { id: "itm_offspring_pig", name: "Pig Offspring",level: 34, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
          ],
        },
        {
          name: "Baby I",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Pig1.gif",
          drops: [
            { id: "itm_turd",        name: "Animal Turd", level: 18, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
            { id: "itm_pig_truffles",name: "Truffles",    level: 18, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
            { id: "itm_pig_pigMilk", name: "Pig Milk",    level: 22, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "2" },
          ],
        },
        {
          name: "Baby II",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Pig2.gif",
          drops: [
            { id: "itm_turd",        name: "Animal Turd",   level: 18, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "4" },
            { id: "itm_pig_truffles",name: "Truffles",      level: 18, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "4" },
            { id: "itm_pig_pigMilk", name: "Pig Milk",      level: 22, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "4" },
            { id: "itm_pig_wings",   name: "Baby Pig Wings",level: 34, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "4" },
          ],
        },
        {
          name: "Baby III",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Pig3.gif",
          drops: [
            { id: "itm_turd",           name: "Animal Turd", level: 18, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "4" },
            { id: "itm_pig_truffles",   name: "Truffles",    level: 18, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "4" },
            { id: "itm_pig_pigMilk",    name: "Pig Milk",    level: 22, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "4" },
            { id: "itm_pig_veggieBacon",name: "Veggie Bacon",level: 36, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "4" },
          ],
        },
        {
          name: "Baby IV",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Pig4.gif",
          drops: [
            { id: "itm_turd",           name: "Animal Turd",  level: 18, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "6" },
            { id: "itm_pig_truffles",   name: "Truffles",     level: 18, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "6" },
            { id: "itm_pig_pigMilk",    name: "Pig Milk",     level: 22, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "6" },
            { id: "itm_pig_wings",      name: "Baby Pig Wings",level: 34, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "6" },
            { id: "itm_pig_veggieBacon",name: "Veggie Bacon", level: 36, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "6" },
            { id: "itm_pig_mudCast",    name: "Mud Cast",     level: 42, feed: "itm_choco_sauce", feedName: "Choco Sauce", feedAmt: "6" },
          ],
        },
      ],
    },
    {
      category: "Goat",
      pets: [
        {
          name: "Adult",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Goat.gif",
          drops: [
            { id: "itm_turd",          name: "Animal Turd",     level: 25, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_goat_goatFur",  name: "Shedded Goat Fur",level: 25, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_goat_goatMilk", name: "Goat Milk",       level: 30, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_offspring_goat",name: "Goat Offspring",  level: 50, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby I",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Goat1.gif",
          drops: [
            { id: "itm_turd",         name: "Animal Turd",     level: 25, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_goat_goatFur", name: "Shedded Goat Fur",level: 25, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
            { id: "itm_goat_goatMilk",name: "Goat Milk",       level: 30, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby II",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Goat2.gif",
          drops: [
            { id: "itm_turd",           name: "Animal Turd",     level: 25, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
            { id: "itm_goat_goatFur",   name: "Shedded Goat Fur",level: 25, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
            { id: "itm_goat_goatMilk",  name: "Goat Milk",       level: 30, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
            { id: "itm_goat_hornFlakes",name: "Tiny Horn Flakes",level: 48, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
          ],
        },
        {
          name: "Baby III",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Goat3.gif",
          drops: [
            { id: "itm_turd",         name: "Animal Turd",     level: 25, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
            { id: "itm_goat_goatFur", name: "Shedded Goat Fur",level: 25, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
            { id: "itm_goat_goatMilk",name: "Goat Milk",       level: 30, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
            { id: "itm_goat_mohair",  name: "Goat Mohair",     level: 55, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "4" },
          ],
        },
        {
          name: "Baby IV",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Goat4.gif",
          drops: [
            { id: "itm_turd",           name: "Animal Turd",      level: 25, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "6" },
            { id: "itm_goat_goatFur",   name: "Shedded Goat Fur", level: 25, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "6" },
            { id: "itm_goat_goatMilk",  name: "Goat Milk",        level: 30, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "6" },
            { id: "itm_goat_hornFlakes",name: "Tiny Horn Flakes",  level: 48, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "6" },
            { id: "itm_goat_mohair",    name: "Goat Mohair",       level: 55, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "6" },
            { id: "itm_goat_sunHorn",   name: "Sunbaked Horn Tip", level: 70, feed: "itm_farmamix", feedName: "Farmamix", feedAmt: "6" },
          ],
        },
      ],
    },
    {
      category: "Duck",
      pets: [
        {
          name: "Adult",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Duck.gif",
          drops: [
            { id: "itm_turd",          name: "Animal Turd",  level: 40, feed: "itm_algamix", feedName: "Algamix", feedAmt: "1" },
            { id: "itm_duck_egg",      name: "Duck Egg",     level: 40, feed: "itm_algamix", feedName: "Algamix", feedAmt: "1" },
            { id: "itm_duck_feather",  name: "Duck Feather", level: 45, feed: "itm_algamix", feedName: "Algamix", feedAmt: "1" },
            { id: "itm_offspring_duck",name: "Duck Offspring",level: 60, feed: "itm_algamix", feedName: "Algamix", feedAmt: "1" },
          ],
        },
        {
          name: "Baby I",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Duck1.gif",
          drops: [
            { id: "itm_turd",        name: "Animal Turd",  level: 40, feed: "itm_algamix", feedName: "Algamix", feedAmt: "1" },
            { id: "itm_duck_egg",    name: "Duck Egg",     level: 40, feed: "itm_algamix", feedName: "Algamix", feedAmt: "1" },
            { id: "itm_duck_feather",name: "Duck Feather", level: 45, feed: "itm_algamix", feedName: "Algamix", feedAmt: "1" },
          ],
        },
        {
          name: "Baby II",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Duck2.gif",
          drops: [
            { id: "itm_turd",          name: "Animal Turd",  level: 40, feed: "itm_algamix", feedName: "Algamix", feedAmt: "2" },
            { id: "itm_duck_egg",      name: "Duck Egg",     level: 40, feed: "itm_algamix", feedName: "Algamix", feedAmt: "2" },
            { id: "itm_duck_feather",  name: "Duck Feather", level: 45, feed: "itm_algamix", feedName: "Algamix", feedAmt: "2" },
            { id: "itm_duck_pondSlime",name: "Pond Slime",   level: 56, feed: "itm_algamix", feedName: "Algamix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby III",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Duck3.gif",
          drops: [
            { id: "itm_turd",          name: "Animal Turd",  level: 40, feed: "itm_algamix", feedName: "Algamix", feedAmt: "2" },
            { id: "itm_duck_egg",      name: "Duck Egg",     level: 40, feed: "itm_algamix", feedName: "Algamix", feedAmt: "2" },
            { id: "itm_duck_feather",  name: "Duck Feather", level: 45, feed: "itm_algamix", feedName: "Algamix", feedAmt: "2" },
            { id: "itm_duck_waterweed",name: "Waterweed",    level: 68, feed: "itm_algamix", feedName: "Algamix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby IV",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Duck4.gif",
          drops: [
            { id: "itm_turd",             name: "Animal Turd",  level: 40, feed: "itm_algamix", feedName: "Algamix", feedAmt: "3" },
            { id: "itm_duck_egg",         name: "Duck Egg",     level: 40, feed: "itm_algamix", feedName: "Algamix", feedAmt: "3" },
            { id: "itm_duck_feather",     name: "Duck Feather", level: 45, feed: "itm_algamix", feedName: "Algamix", feedAmt: "3" },
            { id: "itm_duck_pondSlime",   name: "Pond Slime",   level: 56, feed: "itm_algamix", feedName: "Algamix", feedAmt: "3" },
            { id: "itm_duck_waterweed",   name: "Waterweed",    level: 68, feed: "itm_algamix", feedName: "Algamix", feedAmt: "3" },
            { id: "itm_duck_luckyFeather",name: "Lucky Feather",level: 80, feed: "itm_algamix", feedName: "Algamix", feedAmt: "3" },
          ],
        },
      ],
    },
    {
      category: "Dragon",
      pets: [
        {
          name: "Adult",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Dragon.gif",
          drops: [
            { id: "itm_turd",             name: "Animal Turd",     level: 70, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "1" },
            { id: "itm_dragon_scale",     name: "Dragon Scale",    level: 70, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "1" },
            { id: "itm_dragon_essence",   name: "Draconic Essence",level: 75, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "1" },
            { id: "itm_offspring_dragon", name: "Dragon Offspring",level: 82, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "1" },
          ],
        },
        {
          name: "Baby I",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Dragon1.gif",
          drops: [
            { id: "itm_turd",           name: "Animal Turd",     level: 70, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "1" },
            { id: "itm_dragon_scale",   name: "Dragon Scale",    level: 70, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "1" },
            { id: "itm_dragon_essence", name: "Draconic Essence",level: 75, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "1" },
          ],
        },
        {
          name: "Baby II",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Dragon2.gif",
          drops: [
            { id: "itm_turd",           name: "Animal Turd",     level: 70, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "2" },
            { id: "itm_dragon_scale",   name: "Dragon Scale",    level: 70, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "2" },
            { id: "itm_dragon_essence", name: "Draconic Essence",level: 75, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "2" },
            { id: "itm_dragon_ember",   name: "Ember Shard",     level: 82, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby III",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Dragon3.gif",
          drops: [
            { id: "itm_turd",           name: "Animal Turd",     level: 70, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "2" },
            { id: "itm_dragon_scale",   name: "Dragon Scale",    level: 70, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "2" },
            { id: "itm_dragon_essence", name: "Draconic Essence",level: 75, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "2" },
            { id: "itm_dragon_thread",  name: "Aether Thread",   level: 85, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "2" },
          ],
        },
        {
          name: "Baby IV",
          image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Animals/CC_Baby_Dragon4.gif",
          drops: [
            { id: "itm_turd",           name: "Animal Turd",     level: 70, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "3" },
            { id: "itm_dragon_scale",   name: "Dragon Scale",    level: 70, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "3" },
            { id: "itm_dragon_essence", name: "Draconic Essence",level: 75, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "3" },
            { id: "itm_dragon_ember",   name: "Ember Shard",     level: 82, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "3" },
            { id: "itm_dragon_thread",  name: "Aether Thread",   level: 85, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "3" },
            { id: "itm_dragon_core",    name: "Prismatic Core",  level: 90, feed: "itm_mysticMix", feedName: "Mystic Mix", feedAmt: "3" },
          ],
        },
      ],
    },
  ];

  // Item Modal & Navigation
  const handleOpenModal = async (itemId) => {
    try {
      const data = await fetchItems({ itemId });
      if (data?.[0]) {
        pushModal({
          id: `item-${itemId}`,
          type: "itemModal",
          props: {
            item: data[0],
            onClose: () => {},
            showNavigation: false,
            onNavigate: null,
            totalItems: 1,
            index: null,
          },
        });
      }
    } catch (err) {
      console.error("Failed to fetch item:", err);
    }
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {petCategories.map((categoryData, catIndex) => (
        <div key={catIndex} className="mb-12">
          {/* Category Header */}
          <h2 className="text-2xl font-bold mb-6 text-[var(--text3-color)] border-b-2 border-[var(--border-color)] pb-2">
            {categoryData.category}
          </h2>

          {/* Pets Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {categoryData.pets.map((pet, petIndex) => (
              <div
                key={petIndex}
                className="component-style rounded-lg shadow-lg p-4 hover:shadow-xl transition-shadow"
              >
                {/* Pet Name */}
                <h3 className="font-body font-semibold text-center mb-3">
                  {pet.name}
                </h3>

                {/* Pet Image */}
                <div className="flex justify-center mb-4">
                  <img
                    src={pet.image}
                    alt={pet.name}
                    className="w-24 h-24 object-contain rounded-lg"
                  />
                </div>

                {/* Drops Section */}
                <div className="border-t border-[var(--border-color)] pt-3">
                  <h4 className="text-xs font-semibold text-[var(--text3-color)] mb-2 text-center">
                    Drops
                  </h4>
                  <div className="space-y-1.5">
                    {pet.drops.length > 0 ? (
                      pet.drops.map((drop) => (
                        <button
                          key={drop.id}
                          onClick={() => handleOpenModal(drop.id)}
                          className="w-full px-2 py-1.5 text-xs bg-[var(--entity-mini)] hover:opacity-80 rounded-md transition-all border border-[var(--border-color)] text-left"
                        >
                          <div className="font-semibold truncate text-[var(--text-color)]">
                            {drop.name}
                          </div>
                          <div className="flex items-center gap-2 mt-0.5 text-[var(--text3-color)]">
                            <span>Lv {drop.level}</span>
                            <span className="opacity-40">·</span>
                            <span>{drop.feedName} ×{drop.feedAmt ?? "?"}</span>
                          </div>
                        </button>
                      ))
                    ) : (
                      <p className="text-[var(--text3-color)] text-xs text-center italic">
                        No drops
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PetDrops;